import { BehaviourItem } from '../../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../../coaching-tags/models/subbehaviour.coaching.model';
import { createAction } from '../../../../store.model';
import { BlFocus } from '../../core';
import { ActionType } from '../bl-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reload {}

export const reload = createAction<ActionType, Reload>(
    ActionType.COACHING__BL__RELOAD,
);

export interface ReloadResult extends Reload {
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    focuses?: BlFocus[];
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.COACHING__BL__RELOAD_RESULT,
);
